import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'react-bootstrap';
import { renderActionMenuItems } from './actionMenuUtils';
import './MobileActionMenu.css';

/** Tile/grid icon for mobile actions (2x2 grid of squares) */
const TileIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M4 4h6v6H4V4zm10 0h6v6h-6V4zM4 14h6v6H4v-6zm10 0h6v6h-6v-6z" />
  </svg>
);

/**
 * Mobile-only actions menu – shows a tile icon that opens a dropdown (no duplicate with footer bar).
 * Visible only below md breakpoint (d-md-none). Use alongside DesktopActionMenu in layout headers.
 */
const MobileActionMenu = ({ items = [], className = '', toggleClassName = '', toggleLabel = 'Actions' }) => {
  if (!items || items.length === 0) return null;

  const toggleClasses = `btn btn-transparent layout-mobile-action-menu-toggle ${toggleClassName}`.trim();

  return (
    <div className={`d-md-none layout-mobile-action-menu ${className}`.trim()}>
      <Dropdown alignRight className="layout-mobile-action-menu-dropdown">
        <Dropdown.Toggle id="layout-mobile-action-menu-toggle" className={toggleClasses} aria-haspopup="true" aria-label={toggleLabel}>
          <span className="layout-mobile-action-menu-icon">
            <TileIcon />
          </span>
          <span className="layout-mobile-action-menu-text">{toggleLabel}</span>
        </Dropdown.Toggle>
        <Dropdown.Menu className="layout-mobile-action-menu-menu">
          {renderActionMenuItems(items)}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

MobileActionMenu.propTypes = {
  toggleLabel: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        onClick: PropTypes.func,
      }),
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
      }),
      PropTypes.shape({ divider: PropTypes.bool }),
    ])
  ),
  className: PropTypes.string,
  toggleClassName: PropTypes.string,
};

export default MobileActionMenu;
